import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { history } from '../../helpers/index';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';
import { inviteActions } from '../../actions';
import Strings from '../../common/Strings';
import './ProjectDialog.css';

class RemovePendingInvitationDialog extends React.Component {
  onClickContinue = () => {
    const project = { ...this.props.project };
    const teamMember = { ...this.props.teamMember };

    this.props.dispatch(
      inviteActions.deleteInvitation(project.id, teamMember.email),
    );

    history.goBack();
  };

  render() {
    const { project } = this.props;
    return (
      <Modal
        centered
        open
        size="tiny"
        closeIcon
        onClose={() => history.goBack()}
      >
        <div className="close-project-modal-root">
          <div
            className="close-project-color-container"
            style={{ backgroundColor: project.color }}
          >
            <p className="close-project-title">
              {Strings.PROJECT_DETAILS.removeInvitationDialogTitle}
            </p>
          </div>
          <div className="close-project-content">
            <p className="close-project-header">
              {Strings.PROJECT_DETAILS.removeInvitationDialogHeader}
            </p>
            <p className="close-project-body">
              {Strings.PROJECT_DETAILS.removeInvitationDialogBody}
            </p>
            <div style={{ display: 'flex' }}>
              <Button
                id="project-cancel-button"
                className="common-grey-button"
                onClick={() => history.goBack()}
              >
                {Strings.COMMON.cancel}
              </Button>
              <div style={{ width: 10 }} />
              <Button
                id="project-continue-button"
                className="common-green-button"
                onClick={this.onClickContinue}
              >
                {Strings.COMMON.continue}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

RemovePendingInvitationDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  teamMember: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect()(RemovePendingInvitationDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/RemovePendingInvitationDialog.js